import React, { useEffect } from "react";
import { Plus, Trash, X, Check, Sparkle } from "@phosphor-icons/react";
import { T } from "../themes";
import AIText from "../components/AIText";
import { MEALS, MEAL_ICON } from "../constants";
import Btn from "../components/Btn";
import Spinner from "../components/Spinner";
import BottomNav from "../components/BottomNav";
import AppHeader from "../components/AppHeader";

export default function MyMealsScreen({
  screen,
  setScreen,
  shell,
  phone,
  OfflineBanner,
  hasTargets,
  persona,
  darkMode, setDarkMode,
  session,
  targets,
  totals,
  mealType,
  savedMeals,
  recipeIds,
  recipeTotals,
  recipeIngredients,
  setRecipeIngredients,
  recipeSearch,
  setRecipeSearch,
  recipeResults,
  setRecipeResults,
  recipeSearching,
  recipeName,
  setRecipeName,
  recipeSaving,
  recipeLogModal,
  setRecipeLogModal,
  recipeLogType,
  setRecipeLogType,
  showRecipeBuilder,
  setShowRecipeBuilder,
  recipeSearchFoods,
  recipeAddIngredient,
  recipeUpdateGrams,
  saveRecipe,
  deleteSavedMeal,
  logSavedMeal,
  MEAL_COLOR,
  mealSuggestions,
  mealSugLoading,
  mealSugErr,
  getMealSuggestions,
  mealPrepData,
  mealPrepLoading,
  mealPrepError,
  setMealPrepData,
  onRunMealPrep,
}) {
  const favourites = savedMeals.filter(m => !recipeIds.has(m.id));
  const recipes    = savedMeals.filter(m => recipeIds.has(m.id));
  const tot = recipeTotals();

  // Lock background scroll when recipe builder modal is open
  useEffect(() => {
    if (showRecipeBuilder) {
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = ""; };
    }
  }, [showRecipeBuilder]);

  return (
    <div style={shell}><div style={{...phone,background:T.pageBg}}>
      {OfflineBanner}

      {/* ── Header ─────────────────────────────────────────────────── */}
      <AppHeader
        title="My Meals"
        subtitle="Recipes & meal planning"
        persona={persona}
        darkMode={darkMode}
        onToggleDarkMode={()=>setDarkMode(d=>!d)}
        currentApp="nutri"
        onAvatarPress={()=>setScreen&&setScreen("settings")}
        username={session?.user?.email}
      />

      <div style={{padding:"0 16px",overflowY:"auto",flex:1,paddingBottom:24}}>

        {/* ── Consolidated empty state — shown only when BOTH sections empty ── */}
        {favourites.length===0&&recipes.length===0&&(
          <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,padding:"24px 20px",marginBottom:8,textAlign:"center"}}>
            <div style={{fontSize:36,marginBottom:10,opacity:0.5}}>🍽️</div>
            <p style={{fontFamily:T.fontDisplay,fontSize:16,fontWeight:800,color:T.inkDark,margin:"0 0 6px"}}>Nothing saved yet</p>
            <p style={{color:T.inkMuted,fontSize:12,fontFamily:T.fontSans,lineHeight:1.5,margin:"0 0 18px"}}>
              Star items from your food log to add favourites, or build a recipe from ingredients.
            </p>
            <div style={{display:"flex",gap:8,justifyContent:"center"}}>
              <button onClick={()=>setScreen&&setScreen("today")} style={{background:T.orange,border:"none",borderRadius:T.radiusSm,padding:"10px 18px",cursor:"pointer"}}>
                <span style={{fontSize:12,fontWeight:700,color:"#fff",fontFamily:T.fontSans}}>Browse foods</span>
              </button>
              <button onClick={()=>{setShowRecipeBuilder(true);setRecipeIngredients([]);setRecipeName("");setRecipeSearch("");setRecipeResults("");}}
                style={{background:T.surfaceLight,border:`1px solid ${T.cardBorder}`,borderRadius:T.radiusSm,padding:"10px 18px",cursor:"pointer"}}>
                <span style={{fontSize:12,fontWeight:700,color:T.inkDark,fontFamily:T.fontSans}}>Create recipe</span>
              </button>
            </div>
          </div>
        )}

        {/* ── Quick Add Favourites — shown when not both-empty ─────────── */}
        {(favourites.length>0||recipes.length>0)&&(
        <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,overflow:"hidden",marginBottom:8}}>
          {/* Dark header strip */}
          <div style={{background:T.tileBg,padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <p style={{fontFamily:T.fontDisplay,fontSize:16,fontWeight:800,color:T.tileText,margin:0}}>Quick add favourites</p>
              <p style={{color:"rgba(255,255,255,0.6)",fontSize:10,fontFamily:T.fontDisplay,fontWeight:500,margin:"2px 0 0"}}>Items starred from your food log</p>
            </div>
          </div>
          {favourites.length===0?(
            <div style={{padding:"10px 16px"}}>
              <p style={{color:T.inkMuted,fontSize:11,fontFamily:T.fontSans,margin:0,fontStyle:"italic"}}>No favourites yet — star items from your food log to add them here.</p>
            </div>
          ):(
            favourites.map((m,i)=>(
              <div key={m.id} style={{padding:"12px 16px",
                borderBottom:i<favourites.length-1?`1px solid ${T.cardBorder}`:"none",
                display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                <div style={{flex:1,minWidth:0}}>
                  <p style={{color:T.inkDark,fontSize:13,fontFamily:T.fontDisplay,fontWeight:700,
                    margin:0,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{m.name}</p>
                  <p style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,fontWeight:600,margin:"2px 0 0"}}>
                    {Math.round(m.calories)} kcal · P:{Math.round(m.protein)}g · C:{Math.round(m.carbs)}g · F:{Math.round(m.fat)}g
                  </p>
                </div>
                <div style={{display:"flex",gap:5,flexShrink:0}}>
                  <button onClick={()=>{setRecipeLogModal(m);setRecipeLogType(mealType||"Breakfast");}}
                    style={{background:T.orange,border:"none",borderRadius:12,
                      padding:"10px 16px",cursor:"pointer",color:"#fff",
                      fontSize:11,fontFamily:T.fontDisplay,fontWeight:700}}>
                    + Log
                  </button>
                  <button onClick={()=>deleteSavedMeal(m.id)}
                    style={{background:T.surfaceLight,border:"none",borderRadius:12,padding:"10px 12px",
                      cursor:"pointer",color:T.primary,display:"flex",alignItems:"center"}}>
                    <Trash size={14} weight="bold"/>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        )}

        {/* ── Recipes ───────────────────────────────────────────────── */}
        <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,overflow:"hidden",marginBottom:8}}>
          {/* Dark header strip */}
          <div style={{background:T.tileBg,padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <p style={{fontFamily:T.fontDisplay,fontSize:16,fontWeight:800,color:T.tileText,margin:0}}>Recipes</p>
              <p style={{color:"rgba(255,255,255,0.6)",fontSize:10,fontFamily:T.fontDisplay,fontWeight:500,margin:"2px 0 0"}}>Built from ingredients · saved totals</p>
            </div>
            <button onClick={()=>{setShowRecipeBuilder(true);setRecipeIngredients([]);setRecipeName("");setRecipeSearch("");setRecipeResults("");}}
              style={{background:T.orange,border:"none",borderRadius:12,
                padding:"7px 14px",cursor:"pointer",color:"#fff",
                fontSize:12,fontFamily:T.fontDisplay,fontWeight:700,
                display:"flex",alignItems:"center",gap:5}}>
              <Plus size={13} weight="bold"/> Build recipe
            </button>
          </div>
          {recipes.length===0?(
            <div style={{padding:"10px 16px"}}>
              <p style={{color:T.inkMuted,fontSize:11,fontFamily:T.fontSans,margin:0,fontStyle:"italic"}}>No recipes yet — tap Build recipe to create one.</p>
            </div>
          ):(
            recipes.map((m,i)=>(
              <div key={m.id} style={{padding:"12px 16px",
                borderBottom:i<recipes.length-1?`1px solid ${T.cardBorder}`:"none",
                display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                <div style={{flex:1,minWidth:0}}>
                  <p style={{color:T.inkDark,fontSize:13,fontFamily:T.fontDisplay,fontWeight:700,
                    margin:0,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{m.name}</p>
                  <p style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,fontWeight:600,margin:"2px 0 0"}}>
                    {Math.round(m.calories)} kcal · P:{Math.round(m.protein)}g · C:{Math.round(m.carbs)}g · F:{Math.round(m.fat)}g
                  </p>
                </div>
                <div style={{display:"flex",gap:5,flexShrink:0}}>
                  <button onClick={()=>{setRecipeLogModal(m);setRecipeLogType(mealType||"Breakfast");}}
                    style={{background:T.orange,border:"none",borderRadius:12,
                      padding:"10px 16px",cursor:"pointer",color:"#fff",
                      fontSize:11,fontFamily:T.fontDisplay,fontWeight:700}}>
                    + Log
                  </button>
                  <button onClick={()=>deleteSavedMeal(m.id)}
                    style={{background:T.surfaceLight,border:"none",borderRadius:12,padding:"10px 12px",
                      cursor:"pointer",color:T.primary,display:"flex",alignItems:"center"}}>
                    <Trash size={14} weight="bold"/>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* ── AI Meal Ideas ─────────────────────────────────────────── */}
        {hasTargets&&targets.calories>0&&(
          <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,overflow:"hidden",marginBottom:8}}>
            {/* Dark header */}
            <div style={{backgroundColor:T.tileBg,padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid rgba(255,255,255,0.08)"}}>
              <div>
                <p style={{color:T.tileAccent,fontSize:11,fontWeight:700,fontFamily:T.fontSans,letterSpacing:"0.5px",margin:"0 0 3px"}}>AI suggestions</p>
                <p style={{color:T.tileText,fontSize:16,fontWeight:700,fontFamily:T.fontDisplay,margin:0}}>Meal ideas</p>
                <p style={{color:"rgba(255,255,255,0.6)",fontSize:12,fontFamily:T.fontSans,fontWeight:500,margin:"3px 0 0"}}>
                  Based on your remaining macro budget
                </p>
              </div>
              <button onClick={getMealSuggestions} disabled={mealSugLoading} style={{
                background:T.orange,border:"none",borderRadius:12,
                padding:"7px 14px",cursor:"pointer",color:"#fff",
                fontSize:11,fontFamily:T.fontDisplay,fontWeight:700,
                opacity:mealSugLoading?0.6:1,flexShrink:0,
                display:"flex",alignItems:"center",gap:4,
              }}>
                {mealSugLoading?<Spinner size={10}/>:<><Sparkle size={12} weight="fill"/> Suggest</>}
              </button>
            </div>
            {/* Body */}
            <div style={{padding:16}}>
              {mealSugErr&&<p style={{margin:"0 0 6px",fontSize:10,fontFamily:T.fontDisplay,color:T.red,fontWeight:700}}>{mealSugErr}</p>}
              {mealSuggestions.length===0&&!mealSugLoading&&!mealSugErr&&(
                <>
                  <p style={{margin:"0 0 10px",fontSize:11,fontFamily:T.fontDisplay,color:T.inkMuted,fontStyle:"italic"}}>
                    {totals.calories>=targets.calories
                      ? "You have hit your calorie target today."
                      : `Tap Suggest for meal ideas — ${Math.round(targets.calories-totals.calories)} kcal remaining.`}
                  </p>
                  <div style={{opacity:0.35,pointerEvents:"none"}}>
                    {[
                      {name:"Chicken breast + rice",kcal:420},
                      {name:"Greek yoghurt + berries",kcal:180},
                      {name:"Egg omelette + avocado",kcal:310},
                    ].map((m,i)=>(
                      <div key={i} style={{display:"flex",justifyContent:"space-between",paddingTop:6,paddingBottom:6,borderBottom:i<2?`1px solid ${T.cardBorder}`:"none"}}>
                        <span style={{fontFamily:T.fontSans,fontSize:13,color:T.inkDark}}>{m.name}</span>
                        <span style={{fontFamily:T.fontSans,fontSize:13,color:T.inkMuted}}>{m.kcal} kcal</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
              {mealSuggestions.map((m,i)=>(
                <div key={i} style={{paddingBottom:10,marginBottom:10,borderBottom:i<mealSuggestions.length-1?`1px solid ${T.cardBorder}`:"none"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:3}}>
                    <p style={{margin:0,fontSize:13,fontFamily:T.fontDisplay,fontWeight:700,color:T.inkDark}}>{m.name}</p>
                    <button onClick={()=>setRecipeLogModal(m)} style={{
                      background:T.orange,border:"none",borderRadius:12,
                      padding:"10px 16px",cursor:"pointer",color:"#fff",
                      fontSize:11,fontFamily:T.fontDisplay,fontWeight:700,
                      flexShrink:0,
                    }}>+ Log</button>
                  </div>
                  <p style={{margin:"0 0 4px",fontSize:11,fontFamily:T.fontDisplay,color:T.inkMuted}}><AIText text={m.description} persona={persona}/></p>
                  {m.name&&<a href={`https://www.youtube.com/results?search_query=${encodeURIComponent(m.name+" recipe")}`} target="_blank" rel="noopener noreferrer" style={{display:"inline-block",margin:"0 0 4px",fontSize:10,fontFamily:T.fontDisplay,color:T.primary,textDecoration:"none",fontWeight:700}}>▶ Watch recipe</a>}
                  <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                    {[{l:"Kcal",v:m.calories},{l:"P",v:m.protein+"g"},{l:"C",v:m.carbs+"g"},{l:"F",v:m.fat+"g"}].map(({l,v})=>(
                      <span key={l} style={{fontSize:10,fontFamily:T.fontDisplay,color:T.inkMuted,fontWeight:600}}>
                        <span style={{color:T.inkFaint}}>{l}: </span>{v}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── Weekly Meal Plan ─────────────────────────────────────────── */}
        <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,overflow:"hidden",marginBottom:8}}>
          <div style={{background:T.tileBg,padding:"11px 16px"}}>
            <p style={{fontFamily:T.fontDisplay,fontSize:16,fontWeight:800,color:"#fff",margin:0}}>Weekly meal plan</p>
            <p style={{color:"rgba(255,255,255,0.6)",fontSize:10,fontFamily:T.fontDisplay,fontWeight:500,margin:"2px 0 0"}}>
              3-day plan with shopping list · around your targets
            </p>
          </div>
          <div style={{padding:16}}>
            {mealPrepError&&<p style={{margin:"0 0 8px",fontSize:10,fontFamily:T.fontDisplay,color:T.red,fontWeight:700}}>{mealPrepError}</p>}
            {mealPrepData ? (
              <div>
                {(mealPrepData.prep_sessions||[]).map((day,di) => (
                  <div key={di} style={{background:T.card,borderRadius:T.radius,border:`1px solid ${T.cardBorder}`,overflow:"hidden",marginBottom:8}}>
                    {/* Day header */}
                    <div style={{background:T.tileBg,padding:"8px 14px"}}>
                      <p style={{color:T.tileText,fontFamily:T.fontDisplay,fontSize:14,fontWeight:800,margin:0}}>{day.day}</p>
                    </div>
                    {(day.meals||[]).map((meal,mi) => (
                      <div key={mi} style={{padding:"10px 14px",borderBottom:mi<(day.meals||[]).length-1?`1px solid ${T.cardBorder}`:"none"}}>
                        <p style={{margin:0,fontSize:10,fontFamily:T.fontDisplay,fontWeight:700,color:T.inkMuted,letterSpacing:"0.5px"}}>{meal.slot||meal.name}</p>
                        {meal.slot&&<p style={{margin:"2px 0 0",fontSize:13,fontFamily:T.fontDisplay,fontWeight:700,color:T.inkDark}}>{meal.name}</p>}
                        {meal.prep&&<p style={{margin:"3px 0 0",fontSize:10,fontFamily:T.fontDisplay,color:T.inkMuted,fontStyle:"italic",lineHeight:1.3}}>{meal.prep}</p>}
                        {meal.name&&<a href={`https://www.youtube.com/results?search_query=${encodeURIComponent(meal.name+" recipe")}`} target="_blank" rel="noopener noreferrer" style={{display:"inline-block",margin:"3px 0 0",fontSize:10,fontFamily:T.fontDisplay,color:T.primary,textDecoration:"none",fontWeight:700}}>▶ Watch recipe</a>}
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:3}}>
                          <p style={{margin:0,fontSize:10,fontFamily:T.fontDisplay,color:T.inkMuted}}>P:{meal.protein}g · C:{meal.carbs}g · F:{meal.fat}g</p>
                          <span style={{color:T.orange,fontSize:12,fontWeight:800,fontFamily:T.fontDisplay}}>{meal.calories} kcal</span>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}

                {/* Shopping list */}
                {mealPrepData.shopping_list && mealPrepData.shopping_list.length > 0 && (
                  <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,overflow:"hidden",marginTop:8}}>
                    <div style={{padding:"10px 14px",borderBottom:`1px solid ${T.cardBorder}`}}>
                      <p style={{fontSize:10,fontWeight:700,color:T.inkMuted,fontFamily:T.fontDisplay,margin:0,letterSpacing:"0.5px"}}>Shopping list</p>
                    </div>
                    <div style={{padding:"8px 14px"}}>
                      {mealPrepData.shopping_list.map((item,i) => (
                        <p key={i} style={{margin:"0 0 3px",fontSize:13,fontFamily:T.fontDisplay,fontWeight:600,color:T.inkDark}}>• {item.item} — {item.quantity}</p>
                      ))}
                    </div>
                  </div>
                )}
                <Btn small onClick={()=>setMealPrepData(null)} color={T.inkMuted} style={{marginTop:10}}>Regenerate</Btn>
                <p style={{color:T.disclaimerText||T.inkFaint,fontSize:9,fontFamily:T.fontDisplay,fontWeight:500,textAlign:"center",marginTop:8,lineHeight:1.4}}>AI-generated suggestions. Not nutritional advice. Consult a professional for personalised guidance.</p>
              </div>
            ) : (
              <Btn small onClick={onRunMealPrep} disabled={mealPrepLoading} color={T.orange}>
                {mealPrepLoading ? <><Spinner size={12}/> Planning...</> : "Generate weekly meal plan"}
              </Btn>
            )}
          </div>
        </div>

      </div>

      {/* ── Log meal type picker modal ─────────────────────────────── */}
      {recipeLogModal&&(
        <div style={{position:"fixed",inset:0,background:T.backdrop,
          display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:400}}>
          <div style={{background:T.card,width:"100%",maxWidth:480,padding:"20px 18px 28px",borderRadius:"24px 24px 0 0"}}>
            <p style={{color:T.inkDark,fontSize:14,fontFamily:T.fontDisplay,fontWeight:800,
              margin:"0 0 4px"}}>
              {recipeLogModal.name}
            </p>
            <p style={{color:T.inkMuted,fontSize:11,fontFamily:T.fontDisplay,fontWeight:600,
              margin:"0 0 14px"}}>
              {Math.round(recipeLogModal.calories)} kcal — log to which meal?
            </p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
              {MEALS.map(mt=>(
                <button key={mt} onClick={()=>logSavedMeal(recipeLogModal, mt)}
                  style={{background:MEAL_COLOR[mt],border:"none",borderRadius:12,
                    padding:"11px 0",cursor:"pointer",color:"#fff",
                    fontSize:11,fontFamily:T.fontDisplay,fontWeight:700}}>
                  {MEAL_ICON[mt]} {mt}
                </button>
              ))}
            </div>
            <button onClick={()=>{setRecipeLogModal(null);setRecipeLogType("");}}
              style={{width:"100%",background:T.surfaceLight,border:"none",borderRadius:12,padding:"10px 0",
                cursor:"pointer",color:T.inkMuted,fontSize:11,fontFamily:T.fontDisplay,
                fontWeight:700}}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* ── Recipe Builder Modal ───────────────────────────────────── */}
      {showRecipeBuilder&&(
        <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",background:T.backdrop,
          display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
          <div style={{background:T.card,
            width:"90%",maxWidth:480,maxHeight:"85vh",display:"flex",flexDirection:"column",
            borderRadius:24,overflow:"hidden"}}>

            {/* Builder header */}
            <div style={{background:T.tileBg,padding:"14px 16px",
              display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
              <div>
                <p style={{color:"#fff",fontSize:16,fontFamily:T.fontDisplay,fontWeight:800,
                  margin:0}}>Build recipe</p>
                <p style={{color:"rgba(255,255,255,0.6)",fontSize:10,fontFamily:T.fontDisplay,fontWeight:500,margin:"2px 0 0"}}>
                  {recipeIngredients.length} ingredient{recipeIngredients.length!==1?"s":""} added
                </p>
              </div>
              <button onClick={()=>setShowRecipeBuilder(false)}
                style={{background:"rgba(255,255,255,0.15)",border:"none",cursor:"pointer",
                  color:"#fff",padding:6,display:"flex",borderRadius:8}}>
                <X size={16} weight="bold"/>
              </button>
            </div>

            <div style={{overflowY:"auto",flex:1,padding:"12px 16px"}}>

              {/* Recipe name */}
              <div style={{marginBottom:12}}>
                <label style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,fontWeight:700,
                  display:"block",marginBottom:4}}>
                  Recipe name
                </label>
                <input value={recipeName}
                  onChange={e=>setRecipeName(e.target.value)}
                  placeholder="e.g. Chicken Stir Fry"
                  style={{width:"100%",background:T.surfaceLight,border:`1px solid ${T.cardBorder}`,
                    borderRadius:12,padding:"10px 12px",color:T.inkDark,
                    fontSize:13,fontFamily:T.fontDisplay,fontWeight:600,
                    outline:"none",boxSizing:"border-box"}}/>
              </div>

              {/* Ingredient search */}
              <div style={{marginBottom:10,position:"relative"}}>
                <label style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,fontWeight:700,
                  display:"block",marginBottom:4}}>
                  Add ingredient
                </label>
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                  <input value={recipeSearch}
                    onChange={e=>{
                      setRecipeSearch(e.target.value);
                      if(e.target.value.length>=2) recipeSearchFoods(e.target.value);
                      else setRecipeResults([]);
                    }}
                    placeholder="Search food database..."
                    style={{flex:1,background:T.surfaceLight,border:`1px solid ${T.cardBorder}`,
                      borderRadius:12,padding:"10px 12px",color:T.inkDark,
                      fontSize:12,fontFamily:T.fontDisplay,fontWeight:600,
                      outline:"none"}}/>
                  {recipeSearching&&<Spinner size={14}/>}
                </div>
                {recipeResults.length>0&&(
                  <div style={{position:"absolute",top:"100%",left:0,right:0,
                    background:T.card,border:`1px solid ${T.cardBorder}`,boxShadow:"0 4px 12px rgba(0,0,0,0.1)",
                    zIndex:10,maxHeight:220,overflowY:"auto",borderRadius:12}}>
                    {recipeResults.map((row,i)=>(
                      <button key={row.id||i} onClick={()=>recipeAddIngredient(row)}
                        style={{display:"block",width:"100%",textAlign:"left",
                          background:"none",border:"none",
                          borderBottom:i<recipeResults.length-1?`1px solid ${T.cardBorder}`:"none",
                          padding:"10px 12px",cursor:"pointer"}}>
                        <p style={{color:T.inkDark,fontSize:12,fontFamily:T.fontDisplay,
                          fontWeight:700,margin:0}}>
                          {row.name}{row.brand?` (${row.brand})`:""}
                        </p>
                        <p style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,
                          fontWeight:600,margin:"1px 0 0"}}>
                          {row.calories_per_100g} kcal · P:{row.protein_per_100g}g per 100g
                          {row.cooking_state&&row.cooking_state!=="n/a"?` · ${row.cooking_state}`:""}
                        </p>
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Ingredient list */}
              {recipeIngredients.length===0?(
                <p style={{color:T.inkMuted,fontSize:11,fontFamily:T.fontDisplay,fontWeight:600,
                  textAlign:"center",padding:"12px 0",margin:0,fontStyle:"italic"}}>
                  Search above to add ingredients
                </p>
              ):(
                <div style={{marginBottom:4}}>
                  <p style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,fontWeight:700,
                    marginBottom:6}}>Ingredients</p>
                  {recipeIngredients.map((ing,i)=>(
                    <div key={i} style={{background:T.surfaceLight,border:`1px solid ${T.cardBorder}`,
                      padding:"8px 10px",marginBottom:5,borderRadius:12}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <div style={{flex:1,minWidth:0}}>
                          <p style={{color:T.inkDark,fontSize:12,fontFamily:T.fontDisplay,
                            fontWeight:700,margin:0,whiteSpace:"nowrap",
                            overflow:"hidden",textOverflow:"ellipsis"}}>{ing.name}</p>
                        </div>
                        <input type="number" min="1" value={ing.grams}
                          onChange={e=>recipeUpdateGrams(i,e.target.value)}
                          style={{width:52,background:T.card,border:`1px solid ${T.cardBorder}`,borderRadius:8,
                            padding:"3px 5px",color:T.inkDark,fontSize:11,
                            fontFamily:T.fontDisplay,fontWeight:600,
                            textAlign:"right",outline:"none"}}/>
                        <span style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,
                          fontWeight:600}}>g</span>
                        <button onClick={()=>setRecipeIngredients(p=>p.filter((_,j)=>j!==i))}
                          style={{background:"none",border:"none",cursor:"pointer",
                            color:T.inkMuted,padding:"2px",display:"flex"}}>
                          <X size={12} weight="bold"/>
                        </button>
                      </div>
                      <p style={{color:T.inkMuted,fontSize:9,fontFamily:T.fontDisplay,fontWeight:600,
                        margin:"3px 0 0"}}>
                        {ing.calories} kcal · P:{ing.protein}g · C:{ing.carbs}g · F:{ing.fat}g
                      </p>
                    </div>
                  ))}
                </div>
              )}

              {/* Running totals */}
              {recipeIngredients.length>0&&(
                <div style={{background:T.surfaceLight,border:`1px solid ${T.cardBorder}`,padding:"10px 12px",
                  marginBottom:8,borderRadius:12}}>
                  <p style={{color:T.inkMuted,fontSize:10,fontFamily:T.fontDisplay,
                    fontWeight:700,
                    margin:"0 0 6px"}}>Recipe totals</p>
                  <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                    {[
                      {l:"Kcal",   v:tot.calories,  u:""},
                      {l:"Protein",v:tot.protein,   u:"g"},
                      {l:"Carbs",  v:tot.carbs,     u:"g"},
                      {l:"Fat",    v:tot.fat,       u:"g"},
                      {l:"Fibre",  v:tot.fibre,     u:"g"},
                    ].map(m=>(
                      <div key={m.l} style={{textAlign:"center"}}>
                        <p style={{color:T.inkMuted,fontSize:9,fontFamily:T.fontDisplay,
                          fontWeight:600,margin:0}}>{m.l}</p>
                        <p style={{color:T.inkDark,fontSize:14,fontFamily:T.fontDisplay,
                          fontWeight:800,margin:0}}>{m.v}{m.u}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>

            {/* Builder footer */}
            <div style={{padding:"12px 16px",borderTop:`1px solid ${T.cardBorder}`,flexShrink:0}}>
              <Btn onClick={saveRecipe}
                disabled={recipeSaving||!recipeName.trim()||recipeIngredients.length===0}
                color={T.orange}>
                {recipeSaving
                  ?<><Spinner size={14}/> Saving...</>
                  :<><Check size={14} weight="bold"/> Save recipe</>}
              </Btn>
            </div>

          </div>
        </div>
      )}

      <BottomNav screen={screen} setScreen={setScreen} hasTargets={hasTargets}/>
    </div></div>
  );
}
